'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isErrorAction = undefined;

var _ignoreError = require('./ignoreError');

var _hasErrorMeta = require('./hasErrorMeta');

var ERROR_ACTION_REGEX = /.+_(FAILED|FAILURE)/;

var isErrorAction = exports.isErrorAction = function isErrorAction(action) {
  if (ERROR_ACTION_REGEX.test(action.type) && !(0, _ignoreError.ignoreError)(action)) {
    return true;
  }

  if ((0, _hasErrorMeta.hasErrorMeta)(action) && !(0, _ignoreError.ignoreError)(action)) {
    return true;
  }

  return false;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/action/operators/isErrorAction.js
// module id = 608
// module chunks = 2 3